import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card,
  Spinner,
  Table,
} from 'react-bootstrap';
import config from '../../../../config';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';

const DataDiri = () => {
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${config.API_BASE_URL}api/account/detail-info/`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        setInfo(data);
        setLoading(false);
      },
    );
  }, []);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <Card>
      <Card.Header>Data Diri</Card.Header>
      <Card.Body>
        <Table>
          <tr>
            <td>Nama:</td>
            <td>{info.user.name}</td>
          </tr>
          <tr>
            <td>NPM:</td>
            <td>{info.user.npmnip}</td>
          </tr>
          <tr>
            <td>Angkatan:</td>
            <td>{info.angkatan}</td>
          </tr>
          <tr>
            <td>Program Studi:</td>
            <td>{info.prodi}</td>
          </tr>
          <tr>
            <td>Alamat email:</td>
            <td>{`${info.user.username}@ui.ac.id`}</td>
          </tr>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default DataDiri;
